import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=26b93d37"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default,Theme4PlayerBalance: require('/app/components/Theme4/PlayerBalance.vue').default,Theme4DesktopNavProfileDropdown: require('/app/components/Theme4/Desktop/Nav/ProfileDropdown.vue').default,Theme4DesktopNavNotificationDropdown: require('/app/components/Theme4/Desktop/Nav/NotificationDropdown.vue').default,Theme4ComponentsSwitchLanguage: require('/app/components/Theme4/Components/SwitchLanguage.vue').default,Theme4SideNavMini: require('/app/components/Theme4/SideNavMini.vue').default,Theme4SideNav: require('/app/components/Theme4/SideNav.vue').default,Theme4DesktopTopDepositRanking: require('/app/components/Theme4/Desktop/TopDepositRanking.vue').default})
